<template>
  <div
    v-if="hasActionPermission('my_collection_source_from')"
    class="source-from"
    :class="{
      'source-hover':
        showHover && hasActionPermission('my_collection_source_click'),
    }"
    @click="goLink(source)"
  >
    {{ $t('lai-yuan') }}-{{ COLLECTION_SOURCE_MAP()[source] }}
  </div>
</template>

<script lang="ts" setup>
import { PageKey } from '~/constants/page'
import {
  COLLECTION_MAP,
  COLLECTION_SOURCE,
  RESOURCE_TYPE_CONFIG,
} from '~/utils/constant'

const props = defineProps<{
  source: COLLECTION_SOURCE
  modelType?: COLLECTION_MAP
  resourceType?: RESOURCE_TYPE_CONFIG
}>()

const router = useRouter()
const { hasActionPermission } = usePageAndActionPermissionData()

const showHover = computed(() => {
  if (props.source === COLLECTION_SOURCE.YOUYAN) {
    return props.modelType === COLLECTION_MAP.PIECES_TEMPLATE
  }

  return true
})

const goLink = (source: number) => {
  if (!hasActionPermission('my_collection_source_click')) {
    return
  }

  let target = ''
  let click = SOURCE.PLATFORM

  if (props.modelType !== COLLECTION_MAP.SOURCE) {
    target = TAB_TRACK_KEY[props.modelType!]
  } else {
    target = TAB_TRACK_KEY[COLLECTION_MAP.SOURCE][props.resourceType!]
  }

  switch (source) {
    case COLLECTION_SOURCE.PERSON:
      click = SOURCE.MYSPACE
      router.push({
        name: PageKey.PERSONAL_SPACE,
        query: {
          model_type: props.modelType,
          resource_type: props.resourceType,
        },
      })
      break
    case COLLECTION_SOURCE.TEAM:
      click = SOURCE.TEAM_SPACE
      router.push({
        name: PageKey.TEAM_SPACE,
        query: {
          model_type: props.modelType,
          resource_type: props.resourceType,
        },
      })
      break
    case COLLECTION_SOURCE.SHARE:
      click = SOURCE.SHARE_WITH_ME
      router.push({
        name: PageKey.TEAM_SPACE,
        query: {
          model_type: props.modelType,
          resource_type: props.resourceType,
          share: 2,
        },
      })
      break
    case COLLECTION_SOURCE.YOUYAN:
      if (!isGlobalVersion()) {
        click = SOURCE.PLATFORM
        if (props.modelType === COLLECTION_MAP.PIECES_TEMPLATE) {
          router.push({ name: PageKey.TEMPLATE })
        }
      }
      break
    default:
      break
  }

  trackEvent(TRACK_EVENT.CLICK_SOURCE_TAG, {
    target,
    click,
  })
}
</script>

<style lang="scss" scoped>
.source-from {
  @apply inline-block self-start text-[12px] p-1 text-font-1  mt-[7px];
  background: var(--back-5);
  border-radius: 4px;
}
.source-hover {
  @apply cursor-pointer;
  &:hover {
    background: var(--purple-3);
  }
}
</style>
